<template>
    <v-card
      width="100%"
      :color="getColor"
      ripple
      class="pointer pa-3 d-flex align-center justify-center"
    >
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <span class="subtitle-2 text-center text-truncate" v-on="on">{{ issue.name }}</span>
        </template>
        <span>{{ issue.name }}</span>
      </v-tooltip>
    </v-card>
</template>
<script>
export default {
  name: 'issue-card',
  props: ['issue'],
  computed: {
    getColor () {
      if (this.issue.selected) return 'green lighten-3'
      return ''
    }
  }
}
</script>
